import React, { FormEvent } from 'react'

import { ReceivingFlowController } from '../flow'
import { ScanForm, TaskHeader } from '../styles'
import { ActionButton, RfShell } from '../components/RfShell'
import { RfScanField } from '../components/RfScanField'
import { RfStatusBanner } from '../components/RfStatusBanner'

interface ShipmentReferenceScreenProps {
  controller: ReceivingFlowController
  embedded?: boolean
  onBack: () => void
  onExit: () => void
}

export const ShipmentReferenceScreen = ({
  controller,
  embedded = false,
  onBack,
  onExit,
}: ShipmentReferenceScreenProps) => {
  const { state, dispatch } = controller

  const submitReference = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    dispatch({ type: 'submit-reference' })
  }

  return (
    <RfShell
      title="Receiving"
      phase="Identify ASN"
      embedded={embedded}
      onBack={onBack}
      moreActions={[{ label: 'Exit receiving', onSelect: onExit, danger: true }]}
      actions={
        <ActionButton type="submit" form="shipment-reference-form">
          Continue
        </ActionButton>
      }
    >
      {state.status ? <RfStatusBanner tone={state.status.tone}>{state.status.message}</RfStatusBanner> : null}
      <TaskHeader>
        <h1>Scan shipment reference</h1>
      </TaskHeader>
      <ScanForm id="shipment-reference-form" aria-label="Scan shipment reference" onSubmit={submitReference}>
        <RfScanField
          label="Tracking, BOL, or PRO"
          value={state.reference}
          placeholder="Scan or enter reference"
          hint="Leave blank if unavailable."
          onChange={(reference) => dispatch({ type: 'set-reference', reference })}
        />
      </ScanForm>
    </RfShell>
  )
}
